import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";
import { CASE_STUDIES } from "../data/portfolio";

export default function Portfolio() {
  return (
    <div data-testid="portfolio-page" className="pt-32 md:pt-44">
      <Seo
        title="Case Studies & Results | Quexify"
        description="Real results from agents, teams and brokerages who put a Quexify right hand behind their business. Hours reclaimed, deals closed, growth unlocked."
        path="/portfolio"
      />
      <section className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <h1 className="font-display text-5xl md:text-8xl tracking-tighter font-medium leading-[0.9] max-w-4xl">
            Proof, not promises.
          </h1>
          <p className="mt-8 text-lg md:text-xl text-neutral-500 max-w-2xl leading-relaxed">
            A look at what happens when agents and teams hand the busywork to a Quexify right hand and get back to growing. More studies added as we publish them.
          </p>
        </Reveal>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid md:grid-cols-2 gap-6">
          {CASE_STUDIES.map((c, i) => (
            <Reveal key={c.client} delay={(i % 2) * 0.08}>
              <Link to={`/portfolio/${c.slug}`} className="group block h-full rounded-3xl border border-black/10 p-8 md:p-10 transition-colors duration-500 hover:bg-[#0a0a0a] hover:text-white" data-testid={`case-study-${i}`}>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-neutral-400">{c.tag}</span>
                  <span className="text-sm text-neutral-400">{c.location}</span>
                </div>
                <h2 className="mt-6 font-display text-3xl tracking-tight font-medium flex items-center gap-2">
                  {c.client}
                  <ArrowUpRight size={22} className="opacity-0 -translate-x-1 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0" />
                </h2>
                <p className="mt-2 font-display text-xl tracking-tight text-neutral-500 group-hover:text-neutral-300 transition-colors">{c.result}</p>
                <p className="mt-5 text-neutral-500 group-hover:text-neutral-400 leading-relaxed transition-colors">{c.summary}</p>
                <div className="mt-8 grid grid-cols-3 gap-4 pt-6 border-t border-black/10 group-hover:border-white/15 transition-colors">
                  {c.metrics.map((m) => (
                    <div key={m.k}>
                      <div className="font-display text-2xl tracking-tighter font-medium tabular-nums">{m.v}</div>
                      <div className="mt-1 text-xs text-neutral-400">{m.k}</div>
                    </div>
                  ))}
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24 md:pb-40 text-center">
        <Reveal>
          <h2 className="font-display text-4xl md:text-6xl tracking-tighter font-medium leading-[0.95] max-w-3xl mx-auto">
            Your story is the next one.
          </h2>
          <Link to="/book-demo" className="mt-10 inline-flex items-center gap-2 rounded-full bg-[#0a0a0a] text-white px-9 py-4 text-lg transition-transform duration-300 hover:-translate-y-0.5" data-testid="portfolio-cta">
            Book a discovery call <ArrowUpRight size={20} />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
